module.exports = __webpack_public_path__ + "static/media/BariolThin-Italic.ee77bed2.woff2";